import { defineNuxtPlugin, useVisitorIdCookie, useIsKnownCrawler } from '#imports'

export default defineNuxtPlugin({
    name: 'visitorId',
    parallel: true,
    setup() {
        const isCrawler = useIsKnownCrawler()
        const { setVisitorIdCookie } = useVisitorIdCookie()

        if (isCrawler.value) return

        setVisitorIdCookie()
    },
})
